// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2W0zb","inner":"Form_inner__2lLvY","range":"Form_range__2GQAL","name":"Form_name__1rSlg","actions":"Form_actions__2icyg"};